import { C2paProvider } from "@contentauth/react";
import wasmSrc from "c2pa/dist/assets/wasm/toolkit_bg.wasm?url";
import workerSrc from "c2pa/dist/c2pa.worker.min.js?url";
import i18n from "i18next";
import { merge } from "lodash";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeModeProvider } from "./context/ThemeContext";
import "./index.module.scss";
import BriaThemeProvider from "./mobx/BriaThemeProvider";
import MobxProvider from "./mobx/store-provider";
import dashboard_en from "./translations/en/dashboard_en.json";

const loadTranslationFiles = (languageModules: any) => {
	const files = Object.values(languageModules);
	return files.reduce((acc, curr) => merge(acc, curr), {}) as any;
};

const enModules = import.meta.glob("./translations/en/**/*.json", { eager: true });

i18n.init({
	resources: {
		en: {
			translation: loadTranslationFiles(enModules),
			dashboard: dashboard_en,
		},
		// Add translations for other languages here
	},
	lng: "en", // Set the default language
	fallbackLng: "en",
	interpolation: {
		escapeValue: false, // Allows using HTML in translations
	},
	nsSeparator: false,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
	<MobxProvider>
		<C2paProvider
			config={{
				wasmSrc,
				workerSrc,
			}}
		>
			<I18nextProvider i18n={i18n}>
				<ThemeModeProvider>
					<BrowserRouter>
						<BriaThemeProvider>
							<App />
						</BriaThemeProvider>
					</BrowserRouter>
				</ThemeModeProvider>
			</I18nextProvider>
		</C2paProvider>
	</MobxProvider>,
);
